export default "__VITE_ASSET__527be9a6__"